// import React, { useState, useEffect } from 'react';

// const CriticalAlerts = ({ authTokens }) => {
//   const [criticalProjects, setCriticalProjects] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showAll, setShowAll] = useState(false);

//   const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://ess-api-django-a6fc2c26f42e.herokuapp.com';

//   useEffect(() => {
//     fetchCriticalProjects();
    
//     // Poll for critical projects every 5 minutes
//     const interval = setInterval(fetchCriticalProjects, 5 * 60 * 1000);
//     return () => clearInterval(interval);
//   }, []);

//   const fetchCriticalProjects = async () => {
//     try {
//       const response = await fetch(`${API_BASE_URL}/api/timesheet/project-status/critical_projects/`, {
//         headers: {
//           Authorization: "Bearer " + String(authTokens.access),
//           'Content-Type': 'application/json',
//         },
//       });

//       if (!response.ok) {
//         throw new Error('Failed to fetch critical projects');
//       }

//       const data = await response.json();
//       setCriticalProjects(data);
//     } catch (err) {
//       console.error('Failed to fetch critical projects:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading || criticalProjects.length === 0) {
//     return null;
//   }

//   const displayProjects = showAll ? criticalProjects : criticalProjects.slice(0, 3);

//   const styles = {
//     container: {
//       backgroundColor: '#fee2e2',
//       border: '2px solid #ef4444',
//       borderRadius: '12px',
//       padding: '20px',
//       marginBottom: '24px',
//       boxShadow: '0 4px 6px -1px rgba(239, 68, 68, 0.1)'
//     },
//     header: {
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       marginBottom: '16px',
//       flexWrap: 'wrap',
//       gap: '12px'
//     },
//     titleSection: {
//       display: 'flex',
//       alignItems: 'center',
//       gap: '12px'
//     },
//     icon: {
//       fontSize: '24px',
//       animation: 'pulse 2s infinite'
//     },
//     title: {
//       fontSize: '18px',
//       fontWeight: '600',
//       color: '#991b1b',
//       margin: 0
//     },
//     count: {
//       backgroundColor: '#ef4444',
//       color: 'white',
//       padding: '4px 12px',
//       borderRadius: '12px',
//       fontSize: '12px',
//       fontWeight: '600'
//     },
//     toggleBtn: {
//       padding: '6px 12px',
//       backgroundColor: '#dc2626',
//       color: 'white',
//       border: 'none',
//       borderRadius: '6px',
//       cursor: 'pointer',
//       fontSize: '13px',
//       fontWeight: '500',
//       transition: 'all 0.2s'
//     },
//     list: {
//       display: 'flex',
//       flexDirection: 'column',
//       gap: '12px'
//     },
//     item: {
//       backgroundColor: 'white',
//       padding: '16px',
//       borderRadius: '8px',
//       border: '1px solid #fecaca'
//     },
//     projectName: {
//       fontSize: '16px',
//       fontWeight: '600',
//       color: '#111827',
//       marginBottom: '8px'
//     },
//     details: {
//       display: 'flex',
//       justifyContent: 'space-between',
//       fontSize: '13px',
//       color: '#6b7280',
//       marginBottom: '8px',
//       flexWrap: 'wrap',
//       gap: '8px'
//     },
//     time: {
//       color: '#991b1b',
//       fontWeight: '500'
//     },
//     remarksText: {
//       fontSize: '14px',
//       color: '#374151',
//       margin: 0,
//       fontStyle: 'italic',
//       backgroundColor: '#fef3c7',
//       padding: '8px',
//       borderRadius: '4px',
//       borderLeft: '3px solid #f59e0b'
//     }
//   };

//   return (
//     <div style={styles.container}>
//       <div style={styles.header}>
//         <div style={styles.titleSection}>
//           <span style={styles.icon}>🚨</span>
//           <h3 style={styles.title}>Critical Projects Alert</h3>
//           <span style={styles.count}>{criticalProjects.length}</span>
//         </div>
//         {criticalProjects.length > 3 && (
//           <button 
//             style={styles.toggleBtn}
//             onClick={() => setShowAll(!showAll)}
//             onMouseOver={(e) => e.target.style.backgroundColor = '#b91c1c'}
//             onMouseOut={(e) => e.target.style.backgroundColor = '#dc2626'}
//           >
//             {showAll ? 'Show Less' : `Show All (${criticalProjects.length})`}
//           </button>
//         )}
//       </div>

//       <div style={styles.list}>
//         {displayProjects.map(project => (
//           <div key={project.id} style={styles.item}>
//             <div style={styles.projectName}>{project.project_name}</div>
//             <div style={styles.details}>
//               <span>Manager: {project.project_manager?.name}</span>
//               {project.latest_status && (
//                 <span style={styles.time}>
//                   {new Date(project.latest_status.created_at).toLocaleString()}
//                 </span>
//               )}
//             </div>
//             {project.latest_status?.remarks && (
//               <p style={styles.remarksText}>{project.latest_status.remarks}</p>
//             )}
//           </div>
//         ))}
//       </div>

//       <style>
//         {`
//           @keyframes pulse {
//             0%, 100% { opacity: 1; }
//             50% { opacity: 0.5; }
//           }
//         `}
//       </style>
//     </div>
//   );
// };

// export default CriticalAlerts;


import React, { useState, useEffect } from 'react';

const CriticalAlerts = ({ authTokens }) => {
  const [criticalProjects, setCriticalProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAll, setShowAll] = useState(false);

  const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://ess-api-django-a6fc2c26f42e.herokuapp.com';

  useEffect(() => {
    fetchCriticalProjects();
    
    // Poll for critical projects every 5 minutes
    const interval = setInterval(fetchCriticalProjects, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const fetchCriticalProjects = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/timesheet/project-status/critical_projects/`, {
        headers: {
          Authorization: "Bearer " + String(authTokens.access),
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch critical projects');
      }

      const data = await response.json();
      setCriticalProjects(data);
    } catch (err) {
      console.error('Failed to fetch critical projects:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading || criticalProjects.length === 0) {
    return null;
  }

  const displayProjects = showAll ? criticalProjects : criticalProjects.slice(0, 3);

  const styles = {
    container: {
      backgroundColor: '#fee2e2',
      border: '2px solid #ef4444',
      borderRadius: '12px',
      padding: '20px',
      marginBottom: '24px',
      boxShadow: '0 4px 6px -1px rgba(239, 68, 68, 0.1)'
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '16px',
      flexWrap: 'wrap',
      gap: '12px'
    },
    titleSection: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px'
    },
    icon: {
      fontSize: '24px',
      animation: 'pulse 2s infinite'
    },
    title: {
      fontSize: '18px',
      fontWeight: '600',
      color: '#991b1b',
      margin: 0
    },
    count: {
      backgroundColor: '#ef4444',
      color: 'white',
      padding: '4px 12px',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: '600'
    },
    toggleBtn: {
      padding: '6px 12px',
      backgroundColor: '#dc2626',
      color: 'white',
      border: 'none',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '13px',
      fontWeight: '500',
      transition: 'all 0.2s'
    },
    list: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px'
    },
    item: {
      backgroundColor: 'white',
      padding: '16px',
      borderRadius: '8px',
      border: '1px solid #fecaca'
    },
    projectName: {
      fontSize: '16px',
      fontWeight: '600',
      color: '#111827',
      marginBottom: '8px',
      wordWrap: 'break-word',
      overflowWrap: 'break-word'
    },
    details: {
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: '13px',
      color: '#6b7280',
      marginBottom: '8px',
      flexWrap: 'wrap',
      gap: '8px'
    },
    time: {
      color: '#991b1b',
      fontWeight: '500'
    },
    remarksContainer: {
      maxHeight: '100px',
      overflowY: 'auto',
      backgroundColor: '#fef3c7',
      padding: '8px',
      borderRadius: '4px',
      borderLeft: '3px solid #f59e0b'
    },
    remarksText: {
      fontSize: '14px',
      color: '#374151',
      margin: 0,
      fontStyle: 'italic',
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
      whiteSpace: 'pre-wrap'
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div style={styles.titleSection}>
          <span style={styles.icon}>🚨</span>
          <h3 style={styles.title}>Critical Projects Alert</h3>
          <span style={styles.count}>{criticalProjects.length}</span>
        </div>
        {criticalProjects.length > 3 && (
          <button 
            style={styles.toggleBtn}
            onClick={() => setShowAll(!showAll)}
            onMouseOver={(e) => e.target.style.backgroundColor = '#b91c1c'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#dc2626'}
          >
            {showAll ? 'Show Less' : `Show All (${criticalProjects.length})`}
          </button>
        )}
      </div>

      <div style={styles.list}>
        {displayProjects.map(project => (
          <div key={project.id} style={styles.item}>
            <div style={styles.projectName}>{project.project_name}</div>
            <div style={styles.details}>
              <span>Manager: {project.project_manager?.name}</span>
              {project.latest_status && (
                <span style={styles.time}>
                  {new Date(project.latest_status.created_at).toLocaleString()}
                </span>
              )}
            </div>
            {project.latest_status?.remarks && (
              <div style={styles.remarksContainer}>
                <p style={styles.remarksText}>{project.latest_status.remarks}</p>
              </div>
            )}
          </div>
        ))}
      </div>

      <style>
        {`
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
          
          /* Custom scrollbar for remarks */
          .remarks-container::-webkit-scrollbar {
            width: 6px;
          }
          
          .remarks-container::-webkit-scrollbar-track {
            background: #fef3c7;
            border-radius: 4px;
          }
          
          .remarks-container::-webkit-scrollbar-thumb {
            background: #f59e0b;
            border-radius: 4px;
          }
          
          .remarks-container::-webkit-scrollbar-thumb:hover {
            background: #d97706;
          }
        `}
      </style>
    </div>
  );
};

export default CriticalAlerts;